import { deleteApi, getApi, postApi, putApi } from "../../common/api";

export const loginUser = (data: any) => {
    return postApi('/api/auth/login', data);
};

export const registerUser = (data: any) => {
    return postApi('/api/auth/register', data);
};

export const getUser = () => {
    return getApi('/api/users/profile');
};

export const deleteUser = (id: any) => {
    return deleteApi(`/api/users/profile/${id}`);
};
export const deleteWhishlist = (id: any) => {
    return deleteApi(`/api/${id}/remove`);
};

export const updateUser = (id: any, json: any) => {
    return putApi(`/api/users/profile/${id}`, json);
};

export const updateNotificationUser = (id: any, json: any) => {
    return postApi(`/api/users/update-notifications/${id}`, json);
};